"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _publish = _interopRequireDefault(require("../components/tracker/publish"));

var _common = require("@insided/shared/utils/common");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _Analytics = _interopRequireDefault(require("@insided/deprecated-preact-components/analytics/Analytics"));

var _browserDetection = _interopRequireDefault(require("./helpers/browser-detection"));

var _urlGenerator = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/urlGenerator"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _extend = _interopRequireDefault(require("lodash/extend"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _each = _interopRequireDefault(require("lodash/each"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _map = _interopRequireDefault(require("lodash/map"));

var _has = _interopRequireDefault(require("lodash/has"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _uniq = _interopRequireDefault(require("lodash/uniq"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _template = _interopRequireDefault(require("lodash/template"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var TextDecoderLite = require('exports-loader?TextDecoderLite!text-encoder-lite'); // eslint-disable-line


var base64js = require('base64-js');

var $ = require('jquery');

var Backbone = require('backbone');

var Marionette = require('marionette');

var events = require('utils/globalEvents');

var globalEvents = require('utils/globalEvents');

require('backbone-nested-models');

require('components/insided-api');

var TextDecoder = window.TextDecoder || TextDecoderLite;
if (Backbone.history) Backbone.history.start();

function onRequire(cb, options, Module) {
  var data = (0, _extend.default)({}, options.data, {
    el: options.el
  });

  if (options.extend) {
    Module = Module.extend(options.extend);
  }

  var mod = new Module(data);

  if (mod.render) {
    mod.render();
  }

  if (cb) return cb(mod);
}

function errorCatcher(fn) {
  return function () {
    if (!IS_LOCAL) {
      try {
        fn.apply(this, arguments);
      } catch (err) {
        if (window.console) console.error(err);

        try {
          var _window$newrelic;

          (_window$newrelic = window.newrelic) === null || _window$newrelic === void 0 ? void 0 : _window$newrelic.noticeError(err instanceof Error ? err : new Error(String(err)), {
            category: 'SYSTEM'
          });
        } catch (e) {}
      }
    } else {
      fn.apply(this, arguments);
    }
  };
}

function initAnything(cb, options) {
  var afterLoad = onRequire.bind(null, cb, options);

  if (options.model) {
    afterLoad(require('libs/models/' + options.model));
  } else if (options.view) {
    afterLoad(require('libs/views/' + options.view));
  } else if (options.helper) {
    afterLoad(require('libs/helpers/' + options.helper));
  } else if (options.component) {
    afterLoad(require('components/' + options.component + '/index'));
  }
}

function initDataElements(parent) {
  if (!parent) parent = document;
  var tagsToRead = ['model', 'helper', 'view', 'component'];
  tagsToRead.forEach(function (type) {
    var allComponents = parent.querySelectorAll("[data-".concat(type, "]"));

    var _iterator = _createForOfIteratorHelper(allComponents),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var el = _step.value;
        el = $(el);
        var options = {
          el: el
        };
        options[type] = el.data(type);
        options.data = (0, _extend.default)({}, el.data('data'));
        errorCatcher(initAnything)(null, options);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
}

function loadStuff(listOfElementsToLoad, cb) {
  if (!listOfElementsToLoad) return;

  if (!(0, _isArray.default)(listOfElementsToLoad)) {
    listOfElementsToLoad = [listOfElementsToLoad];
  }

  (0, _each.default)(listOfElementsToLoad, errorCatcher(initAnything.bind(null, cb)));
}

function decodeAndApplyConfig(base64Config) {
  if (!base64Config) return;
  var codec = new TextDecoder('utf-8');
  var config;

  try {
    config = JSON.parse(codec.decode(base64js.toByteArray(base64Config)));
  } catch (e) {
    // eslint-disable-next-line
    console.log('Failed to parse config', e);
  }

  if (config) app.init(config);
}

;

(function () {
  var bodyClasses = document.getElementsByTagName('body')[0].classList;
  var currentPage = 'other';

  if (bodyClasses.contains('parent-category')) {
    currentPage = 'parent category';
  } else if (bodyClasses.contains('category-page')) {
    currentPage = 'category';
  } else if (bodyClasses.contains('twig_page-topic')) {
    currentPage = 'topic';
  } else if (bodyClasses.contains('forum--search')) {
    currentPage = 'search';
  } else if (bodyClasses.contains('twig_default-member-profile')) {
    currentPage = 'profile';
  } else if (bodyClasses.contains('twig_site-badges')) {
    currentPage = 'badges';
  } else if (bodyClasses.contains('twig_default-setting-profile')) {
    currentPage = 'settings';
  } else if (bodyClasses.contains('twig_site-index')) {
    currentPage = 'homepage';
  }

  $('[data-track]').on('click', function (e) {
    var el = $(e.currentTarget);
    var standardInfo = {
      'Topic Initiated': {
        user_role: (0, _insidedDataStorage.getInsidedData)('user').role,
        source: (0, _common.getCurrentPage)(),
        button_label: el.text().trim()
      },
      'Sidebar Widget Clicked': {
        click_source: currentPage
      },
      'Destination Configuration Mode Activated': {
        viewport: "".concat(window.innerWidth, "*").concat(window.innerHeight),
        browser: _browserDetection.default
      }
    };
    var userObject = {
      user: (0, _insidedDataStorage.getInsidedData)('user')
    };

    var data = _objectSpread(_objectSpread(_objectSpread({}, el.data('track')), standardInfo[el.data('track').type]), userObject);

    _publish.default.trackEvent('userevent', data);
  });
  $('[data-ga-track]').on('click', function (e) {
    var el = $(e.currentTarget);
    var data = el.data('ga-track');

    _Analytics.default.send(data.eventCategory, data.eventAction, data.eventLabel);
  }); // Event tracker for general settings

  function isChecked(selector) {
    var el = document.querySelector(selector);
    return el ? el.checked : null;
  }

  function receivePrivateMessagesCheck(selector) {
    var checkedResult = isChecked(selector);

    if (checkedResult === null) {
      return checkedResult;
    } else if (checkedResult) {
      return 'Everyone';
    } else {
      return 'People you follow';
    }
  }

  if (window.location.pathname === '/settings/general') {
    var profileSettingsSaveBtn = document.querySelector('.js-submit-general-settings');
    profileSettingsSaveBtn.addEventListener('click', function () {
      window.insided.trackEvent('userevent', {
        type: 'Profile Settings Saved',
        display_badges: isChecked('#GeneralSettingsForm_showbadges_0'),
        display_reputation: isChecked('#GeneralSettingsForm_showreputation_0'),
        display_usertitle: isChecked('#GeneralSettingsForm_showusertitle_0'),
        display_new_activity: isChecked('#GeneralSettingsForm_showunreadpostscounter_0'),
        notification_new_reply: isChecked('#GeneralSettingsForm_addtofavorites_0'),
        notification_new_topic: isChecked('#GeneralSettingsForm_autosubscribe_0'),
        notification_new_mention: isChecked('#GeneralSettingsForm_mentionnotification_0'),
        notification_best_answer: isChecked('#GeneralSettingsForm_bestanswernotification_0'),
        notification_private_message: isChecked('#GeneralSettingsForm_privatemessagesnotification_0'),
        receive_private_messages: receivePrivateMessagesCheck('#GeneralSettingsForm_receivepmbuddies_0')
      });
    });
  }
})();

var originalRender = {
  View: Marionette.View.prototype.render,
  ItemView: Marionette.ItemView.prototype.render,
  LayoutView: Marionette.LayoutView.prototype.render,
  CompositeView: Marionette.CompositeView.prototype.render,
  CollectionView: Marionette.CollectionView.prototype.render
}; // Override render method for each view type

function overrideRender(viewType) {
  Marionette[viewType].prototype.render = function () {
    // Call the original render function
    originalRender[viewType].apply(this, arguments); // Apply custom logic

    this.$el.attr('data-mn', viewType);
    this.$el.attr('data-mn-app', 'frontend');
    return this; // Support chaining
  };
} // Apply the override to each type of Marionette view


overrideRender('View');
overrideRender('ItemView');
overrideRender('LayoutView');
overrideRender('CompositeView');
overrideRender('CollectionView');
var app = {
  $: $,
  Backbone: Backbone,
  Marionette: Marionette,
  _: {
    deepExtend: function deepExtend() {
      return $.extend.apply($, [true].concat(Array.prototype.slice.call(arguments, 0)));
    },
    extend: _extend.default,
    isArray: _isArray.default,
    each: _each.default,
    uniqueId: _uniqueId.default,
    map: _map.default,
    has: _has.default,
    isFunction: _isFunction.default,
    uniq: _uniq.default,
    filter: _filter.default,
    isEmpty: _isEmpty.default,
    template: _template.default,
    isObject: _isObject.default,
    isString: _isString.default
  },
  config: {},
  init: loadStuff,
  initDataElements: initDataElements,
  events: events,
  utils: new Marionette.Application(),
  router: Marionette.AppRouter,
  url: '/',
  libs: {
    topicUrlGenerator: _urlGenerator.default
  },
  decodeAndApplyConfig: decodeAndApplyConfig
}; // global event to be triggered from preact

window.addEventListener('GuestUserAction', function () {
  globalEvents.commands.execute('modal:login:show');
}, false);
setTimeout(function () {
  var _document$getElementB;

  var elementWithConfig = document.getElementById('insided-app');
  if (!elementWithConfig) return;
  var base64Config = elementWithConfig.getAttribute('data-config');
  (0, _globals.default)('region', elementWithConfig.getAttribute('data-region'));
  (0, _globals.default)('environment', elementWithConfig.getAttribute('data-environment'));
  (0, _globals.default)('communityId', elementWithConfig.getAttribute('data-communityId'));
  (0, _globals.default)('eventLogger', document.getElementById('insided-preact-app').getAttribute('data-eventLogger'));
  (0, _globals.default)('cookieConfig', JSON.parse(document.getElementById('insided-preact-app').getAttribute('data-cookieConfig')));
  (0, _globals.default)('defaultCookieLevel', parseInt((_document$getElementB = document.getElementById('insided-preact-app').getAttribute('data-defaultCookieLevel')) !== null && _document$getElementB !== void 0 ? _document$getElementB : '3'));
  (0, _globals.default)('application', document.getElementById('insided-preact-app').getAttribute('data-application'));
  initDataElements();
  decodeAndApplyConfig(base64Config);
});
window.jQuery = $;
window.$ = $;
window.app = app; // to post a notification to index.tsx that app file is loaded.

if (app) {
  var event = new window.CustomEvent('AppEvent');
  window.dispatchEvent(event);
}

module.exports = app;